import { useEffect } from "react";

/**
 * Enables inertia-based smooth scrolling (Lenis) after hydration.
 * Disabled for visitors who prefer reduced motion.
 */
export function SmoothScroll() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce), (pointer: coarse)").matches) return;

    let destroy: (() => void) | undefined;
    let cancelled = false;

    const start = () => { void import("lenis").then(({ default: Lenis }) => {
      if (cancelled) return;
      const lenis = new Lenis({
        duration: 1.05,
        smoothWheel: true,
        touchMultiplier: 1.6,
      });

      let frame = 0;
      const raf = (time: number) => {
        if (document.visibilityState === "visible") lenis.raf(time);
        frame = requestAnimationFrame(raf);
      };
      frame = requestAnimationFrame(raf);

      destroy = () => {
        cancelAnimationFrame(frame);
        lenis.destroy();
      };
    }); };
    window.addEventListener("wheel", start, { passive: true, once: true });

    return () => {
      cancelled = true;
      window.removeEventListener("wheel", start);
      destroy?.();
    };
  }, []);

  return null;
}
